import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import IndividualListingModalV2 from 'src/App/Dashboards/Market/Modals/IndividualListingModalV2';
import { FullScreenAnimationLoader } from 'src/App/Dashboards/Market/Components/Loaders';
import { callApi } from 'src/core/callApi';
import { processIndividualListingData } from 'src/utils/functions';
import { SAMPLE_LISTING_ID } from 'src/utils/const';

const dymmyData = {
  listingID: '51143337',
  name: 'Mountain View Home | Access to Bozeman & Beyond',
  thumbnail_url:
    'https://a0.muscache.com/im/pictures/miso/Hosting-51143337/original/49b5aa7f-636b-4717-9db9-186ec9a42d2c.jpeg?aki_policy=small',
  latitude: 45.79194,
  longitude: -111.14131,
  bedrooms: '2',
  bathrooms: 2,
  accommodates: 5,
  room_type: 'entire_home',
  room_and_property_type: 'Entire home',
  amenities: {
    parking: true,
    hot_tub: false,
    gym: false,
    pets: false,
    dryer: true,
    washer: true,
    pool: false,
    kitchen: true,
    ac: true,
    wifi: true,
    heating: true,
    tv: true,
    bbq_grill: false,
    fireplace: false,
    breakfast: false,
    beachfront: false,
    amazing_views: true,
  },
  host_id: '40882397',
  host_name: 'Blake',
  hostListingCount: 1,
  minimum_nights: 4,
  cancellation_policy: 'f',
  license: null,
  reveiw_scores_rating: 98,
  visible_review_count: 68,
  cleaning_fee: 100,
  extra_fee_person_estimate: 0,
  avg_booked_daily_rate_ltm: 148,
  avg_occupancy_rate_ltm: 84,
  annual_revenue_ltm: 34066,
  active_days_count_ltm: 270,
  no_of_bookings_ltm: 5,
  added_on: '2021-10-07',
  property_type: '-1',
  has_license: 'f',
  revenue_potential: 46178,
  last_seen: '2024-08-26',
};

const IndividualListingPage = ({
  user,
  currency,
  isLoggedIn,
  subscriptionModalOpen,
  setSubscriptionModalOpen,
  handleOnSampleClick,
  openDemoBookingForm,
  setDemoFormHeadingFor,
  marketID,
}) => {
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [listingData, setListingData] = useState<any>(null);
  const [isApiRateLimited, setIsApiRateLimited] = useState<boolean>(false);

  const listingIDFromUrl = typeof window !== 'undefined' ? String(window.location.pathname).split('/listing/')[1] : null;

  const isUserAllowed =
    ['pro', 'expert', 'scale'].includes(user.subscriptionPlan) ||
    user.role === 'admin' ||
    listingIDFromUrl === SAMPLE_LISTING_ID;

  useEffect(() => {
    const URL = 'https://8q15spida4.execute-api.us-east-2.amazonaws.com/default/getListingDetails';

    const fetchData = async () => {
      const listingID = String(window.location.pathname).split('/listing/')[1];

      const config = {
        queryParams: {
          listingID: listingID,
          apiType: 'v5',
          marketID: marketID ? marketID : ''
        },
      };
      const resp = await callApi(URL, config, true, false, '', 'GET', true, undefined, true);   
      let listingData = resp?.message;

      if (resp.status === 429) {
        setIsApiRateLimited(true);
      }

      if (listingData) {
        const processedListingData = processIndividualListingData(listingData);
        if(!processedListingData.listingID) {
          processedListingData.listingID = listingID;
        }
        setListingData(processedListingData);
      }

      setIsDataLoading(false);
    };

    if(isLoggedIn){
      fetchData();
    }else{
      setIsModalOpen(false);
      setIsDataLoading(false);
    }

  }, []);

  return (
    <>
      {isDataLoading && <FullScreenAnimationLoader />}

      {!isDataLoading && (
        <IndividualListingModalV2
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          data={listingData ? listingData : dymmyData}
          currency={currency}
          isDisabled={!isUserAllowed}
          setSubscriptionModalOpen={setSubscriptionModalOpen}
          handleOnSampleClick={reqPlan => handleOnSampleClick(reqPlan, 'individualListingsKPI')}
          subscriptionModalOpen={subscriptionModalOpen}
          isEstimator={false}
          openDemoBookingForm={openDemoBookingForm}
          setDemoFormHeadingFor={setDemoFormHeadingFor}
          noListingData={!listingData}
          isApiRateLimited={isApiRateLimited}
          marketID={marketID}
          doNotRefetchListingData={true}
        />
      )}
    </>
  );
};

export default IndividualListingPage;
